import { Prop, Schema, SchemaFactory } from '@nestjs/mongoose';
import { Document } from 'mongoose';
import { MultilingualTextSchema } from '@/common/schemas/multilingual-text.schema';

export type StateDocument = State & Document;

@Schema({ timestamps: true })
export class State {
  @Prop({ type: MultilingualTextSchema, required: true })
  name: { en: string; ar: string };

  @Prop({ type: String, required: true, unique: true })
  code: string; // State code (e.g., "CA", "NY")

  @Prop({ type: Number, required: true, min: 0 })
  shippingCost: number;

  @Prop({ type: String, ref: 'Country', required: true })
  countryId: string;

  @Prop({ type: Boolean, default: true })
  isActive: boolean;

  @Prop({ type: Date, default: Date.now })
  createdAt: Date;

  @Prop({ type: Date, default: Date.now })
  updatedAt: Date;
}

export const StateSchema = SchemaFactory.createForClass(State);